import React, { useMemo } from "react";
import ScoreBadge from "./ScoreBadge";
import { useAuthStore } from "../../store/authStore";
import { CheckCircle, XCircle } from "lucide-react";
import SummaryCell from "./LeadSummaryCell";
import LeadCategory from "./LeadCategory";

export const useColumns = () => {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";

  const columns = useMemo(() => {
    const propertyColumn = {
      title: "Property",
      dataIndex: "property_name",
      render: (text) => (
        <span className="badge badge-property">{text}</span>
      ),
    };

    const crmPushedColumn = { 
        title: "CRM Pushed",
        dataIndex: "crm_pushed",
        align: "center",
        render: (value) => (
          <span className="d-flex align-center justify-center">
            {value ? (
              <CheckCircle size={16} className="text-success" />
            ) : (
              <XCircle size={16} className="text-danger" />
            )}
          </span>
        ),   
    };

    const otherColumns = [
     
      {
        title: "Name",
        dataIndex: "name",
        render: (text) => <span className="fw-medium">{text}</span>,
      },
      {
        title: "Phone",
        dataIndex: "phone",
      },
      {
        title: "Score",
        dataIndex: "score",
        render: (score) => <ScoreBadge score={score} />,
      },
      {
        title: "Category",
        dataIndex: "score",
        render: (score) => <LeadCategory score={score} />,
      },
      {
        title: "Location",
        dataIndex: "location",
        render: (text) => (
          <span className="badge badge-location">{text}</span>
        ),
      },
      {
        title: "Budget",
        dataIndex: "budget",
        render: (text) => (
          <span className="fw-medium text-primary text-nowrap">
            {text !== "—" ? text : "—"}
          </span>
        ),
      },
      {
        title: "Unit Type",
        dataIndex: "unit_type",
        render: (text) => (
          <span className="badge badge-unit-type">{text}</span>
        ),
      },
      {
        title: "Source",
        dataIndex: "source",
        render: (text) => (
          <span className="badge badge-source">{text}</span>
        ),
      },
      {
        title: "Conversation Summary",
        dataIndex: "summary",
        className: "summary-col",
        render: (text) => <SummaryCell text={text} />,
      },
      {
        title: "Activity Summary",
        dataIndex: "activity_summary",
        render: (text) =>
          text && text.trim() ? (
            <SummaryCell
              text={text}
              title="Activity Summary"
            />
          ) : (
            <span className="fw-medium text-primary">
              No activity summary
            </span>
          ),
      }
    ];

    let baseColumns = [];

    if (isAdmin) {
      baseColumns = [
        {
          title: "Agent",
          dataIndex: "agent_name",
          render: (text) => (
            <span className="fw-medium text-primary">{text}</span>
          ),
        },
        propertyColumn,
        ...otherColumns,
        crmPushedColumn,
      ];
    } else {
      // Agent/User view → Property first
      baseColumns = [propertyColumn, ...otherColumns];
    }

    return baseColumns;
  }, [isAdmin]);

  return columns;
};
